import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@core/appconfig.service';
import { ApiResponse } from '@models/api-response';
import {
  ActivityKind,
  ActivityQuery,
  ActivityResponse,
  ActivityUpdate
} from '@services/activity/activity.service.model';
import { instantiateApiResponseFromJsonInterface } from '@shared/zb-rxjs-operators/rxjs-operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  constructor(
    private appConfig: AppConfigService,
    private http: HttpClient,
  ) {
  }

  getVideoActivity(activityQuery: ActivityQuery): Observable<ApiResponse<ActivityResponse | null>> {
    return this.getActivity(ActivityKind.Video, activityQuery);
  }

  getSuperSmartActivity(activityQuery: ActivityQuery): Observable<ApiResponse<ActivityResponse | null>> {
    return this.getActivity(ActivityKind.SuperSmart, activityQuery);
  }

  getResourceActivity(activityQuery: ActivityQuery): Observable<ApiResponse<ActivityResponse | null>> {
    return this.getActivity(ActivityKind.Resource, activityQuery);
  }

  private getActivity(
    activityKind: ActivityKind, activityQuery: ActivityQuery
  ): Observable<ApiResponse<ActivityResponse | null>> {
    const baseUrl = `${this.appConfig.apiUrl}/${activityKind}/student/activity`;
    const url = `${baseUrl}/topic/${activityQuery.topicKey}/product/${activityQuery.productType}/activityKey/${activityQuery.activityKey}`;
    return this.http.get(url).pipe(
      instantiateApiResponseFromJsonInterface<ActivityResponse>()
    );
  }

  updateVideoActivity(activityUpdate: ActivityUpdate): Observable<ApiResponse<ActivityResponse>> {
    return this.updateActivity(ActivityKind.Video, activityUpdate);
  }

  updateSuperSmartActivity(activityUpdate: ActivityUpdate): Observable<ApiResponse<ActivityResponse>> {
    return this.updateActivity(ActivityKind.SuperSmart, activityUpdate);
  }

  updateResourceActivity(activityUpdate: ActivityUpdate): Observable<ApiResponse<ActivityResponse>> {
    return this.updateActivity(ActivityKind.Resource, activityUpdate);
  }

  private updateActivity(
    activityKind: ActivityKind, activityUpdate: ActivityUpdate
  ): Observable<ApiResponse<ActivityResponse>> {
    const url = `${this.appConfig.apiUrl}/${activityKind}/student/activity`;
    return this.http.put(url, activityUpdate).pipe(
      instantiateApiResponseFromJsonInterface<ActivityResponse>()
    );
  }
}
